import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { dateCharacters } from 'utils/constants'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'
import moment from 'moment'
import { formatDate, parseDate } from 'react-day-picker/moment'
import 'styles/d3/datepicker.scss'

const DatePicker = React.forwardRef(
  (
    {
      date,
      disabled,
      disabledDays,
      id,
      initialDate,
      onDayChange,
      onEnterPress,
      onInputChange,
    },
    ref,
  ) => {
    const [valid, setValid] = useState(true)
    const [initialValue, setInitialValue] = useState(
      initialDate ? initialDate.toDate() : '',
    )

    const _value = date ? date.toDate() : initialValue

    const handleBlur = () => {
      if (valid) {
        setInitialValue(initialDate ? initialDate.toDate() : '')
      }
    }

    const _onInputChange = val => {
      onInputChange(val)
    }

    return (
      <DayPickerInput
        inputProps={{
          autoComplete: 'off',
          className: valid ? '' : 'invalid-date',
          disabled,
          id,
          onBlur: handleBlur,
          onChange: e => _onInputChange(e.target.value),
          // readOnly: true, TODO: potentially utilize this in the future to prevent manual string entry
          onKeyPress: e => {
            if (e.key === 'Enter') {
              e.preventDefault()
              if (onEnterPress) onEnterPress()
            }
            if (!dateCharacters.includes(e.key)) e.preventDefault()
          },
          ref,
          // type: 'date', // TODO: use to show native datepicker on mobile devices
        }}
        dayPickerProps={{ disabledDays }}
        formatDate={formatDate}
        parseDate={(str, format) => {
          const parsedDate = parseDate(str, format)
          if (parsedDate && !valid) setValid(true)
          else if (!parsedDate && valid) setValid(false)
          return parsedDate
        }}
        onDayChange={day => {
          if (day) onDayChange(day)
        }}
        value={_value}
        placeholder='MM/DD/YYYY'
      />
    )
  },
)

DatePicker.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
  disabled: PropTypes.bool,
  disabledDays: PropTypes.any,
  id: PropTypes.string,
  initialDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment),
  ]),
  onDayChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onEnterPress: PropTypes.func,
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/components/DatePicker.js